import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../styles/components/Editor.scss";
import "../../styles/components/EditorModal.scss";
import Button from "@mui/material/Button";
import Locksymbol from "../../images/Locksymbol.svg";
import Unlocksymbol from "../../images/UnlockSymbol.svg";

export default function BannerLockUnlockModal({
  setShowLockModal,
  showLockModal,
  assetLockUnlock,
  recentlyViewedData,
  isLocked,
  loading,
}) {
  const { t } = useTranslation();

  const handleClose = () => {
    setShowLockModal(false);
  };
  return (
    <>
      <Dialog
        open={showLockModal}
        onClose={handleClose}
        className="lock-modal"
        aria-labelledby="form-dialog-title"
        overlayStyle={{ backgroundColor: "transparent" }}
      >
        {loading && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress size="30px" className="customLoader" />{" "}
          </>
        )}
        <DialogContent>
          <div className="d-flex">
            <img
              src={isLocked ? Locksymbol : Unlocksymbol}
              alt=""
              className="img-fluid"
            />
            <div className="lock-modalheading">
              {isLocked ? t("Lock Banner") : t("Unlock Banner")}
            </div>
          </div>
          <div className="lock-modalContent ">
            {isLocked
              ? t(
                  "Locking the banner will prevent other users from editing it.",
                )
              : t("Unlocking the banner will allow other users to edit it.")}
            <span>{t(" Are you sure?")}</span>
          </div>
        </DialogContent>
        <DialogActions className="lock-actions">
          <Button
            onClick={handleClose}
            color="primary"
            className="cance-btn cance"
          >
            {t("CANCEL")}
          </Button>
          <Button
            onClick={() => {
              assetLockUnlock(
                recentlyViewedData?.damDocNumber,
                isLocked ? "Locked" : "Unlocked",
                recentlyViewedData?.assetType,
              );
              handleClose();
            }}
            type="submit"
            className="btn btn-primary"
            autoFocus
          >
            {t("PROCEED")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
